import { Divider, Dropdown, Menu, Spin, Tag } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../context/Notification/useNotify';
import ModalDelete from '../../../components/Shared/modal/delete';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import ModalRename from './ModalRename';
import IconWaring from '../../../assets/Images/icons/icon-waring';
import DetailPrivacy from './DetailPrivacy';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import usePermission from '../../../hooks/usePermission';

const ListPrivacy = ({
    data,
    pathEdit,
    stepEdit,
    setCurrentSelectList,
    currentSelectList,
    handelRename,
    currentSelectName,
    policyObject: { privacyName, privacyType, privacyId, privacyCompany },
    loading,
    setLoading,
    form,
    getPolicyList,
    linkName,
    children,
    deleteObject: { serviceDelete, text, title },
    historyObject: {
        serviceHistory,
        historyParamName,
        historyResultIdName,
        type,
    },
    confirmObject,
    templateBody,
    download = true,
}) => {
    const { isAuditor } = usePermission();

    const { t, i18n } = useTranslation();
    const lang = i18n?.language;
    const notify = useNotify();
    const [openRename, setOpenRename] = useState(false);
    const navigate = useNavigate();
    // Delete Consent
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [dataObject, setDataObject] = useState(null);
    const menu = (item) => (
        <Menu
            className="w-28"
            items={[
                {
                    className: 'hover:bg-[#EEE5FF]',
                    label: t('Edit'),
                    onClick: () => {
                        navigate(
                            `${pathEdit}/${item[privacyId]}${
                                item?.status === 'Published'
                                    ? stepEdit
                                    : '#step1'
                            }`
                        );
                    },
                },
                {
                    className: 'hover:bg-[#EEE5FF]',
                    label: t('common.Delete'),
                    onClick: () => {
                        item?.status === 'Draft'
                            ? setOpenDelete(true)
                            : setConfirmDelete(true);
                        setDataObject(item);
                    },
                },
            ]}
        />
    );

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.latestPublishVersion}
                    </Tag>
                );
            default:
                return <>-</>;
        }
    };

    return (
        <>
            <div className="w-full col-span-2">
                <div className="bg-white rounded-md shadow-sm pt-5 pb-5">
                    <div className="text-xs text-right font-semibold text-gray-PHX px-5 mb-4">
                        {t('TotalItems', { length: data?.length || 0 })}
                    </div>
                    <Divider className="mb-0" />
                    <div className="overflow-y-auto overflow-x-hidden max-h-[60vh]">
                        <Spin spinning={loading}>
                            {data?.length > 0 ? (
                                data.map((e, i) => {
                                    return (
                                        <button
                                            key={i}
                                            className={`cursor-pointer custom-list hover:bg-gray-50 w-full text-left ${
                                                currentSelectList &&
                                                currentSelectList[privacyId] ===
                                                    e[privacyId]
                                                    ? 'select'
                                                    : ''
                                            }`}
                                            onClick={() => {
                                                setCurrentSelectList(e);
                                            }}
                                        >
                                            <div />
                                            <div className="my-4 flex w-full items-center">
                                                <div className="flex-1 space-y-2">
                                                    <div className="font-semibold text-gray-500 text-xs">
                                                        {e[privacyType] || '-'}
                                                    </div>
                                                    <div
                                                        style={{
                                                            wordBreak:
                                                                'break-word',
                                                        }}
                                                        className="font-semibold text-purple-PHX text-base whitespace-pre-wrap line-clamp-2"
                                                    >
                                                        {e[privacyName] || '-'}
                                                    </div>
                                                    {/* <div>{_getTagStatus(e)}</div> */}
                                                    <div className="flex items-center">
                                                        {_getTagStatus(e)}
                                                        <div
                                                            className="text-[#F0536F] text-[12px]"
                                                            hidden={
                                                                !e?.hasChanged ||
                                                                e?.status ===
                                                                    'Draft'
                                                            }
                                                        >
                                                            <div className="flex items-center py-2">
                                                                <svg
                                                                    width="10"
                                                                    height="11"
                                                                    viewBox="0 0 10 11"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="5"
                                                                        cy="5.5"
                                                                        r="5"
                                                                        fill={
                                                                            '#F0536F'
                                                                        }
                                                                    />
                                                                </svg>
                                                                <span>
                                                                    &nbsp;&nbsp;
                                                                </span>
                                                                <div>
                                                                    {t(
                                                                        'InformationChanged'
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="hover:opacity-80">
                                                    <Dropdown
                                                        disabled={isAuditor}
                                                        className="disabled:cursor-not-allowed"
                                                        placement="bottomRight"
                                                        arrow
                                                        overlay={menu(e)}
                                                    >
                                                        <button>
                                                            <svg
                                                                width={32}
                                                                height={32}
                                                                viewBox="0 0 32 32"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <rect
                                                                    width={32}
                                                                    height={32}
                                                                    rx={6}
                                                                />
                                                                <path
                                                                    d="M19.75 16C19.75 17.0312 20.5937 17.875 21.625 17.875C22.6562 17.875 23.5 17.0313 23.5 16C23.5 14.9687 22.6563 14.125 21.625 14.125C20.5937 14.125 19.75 14.9687 19.75 16Z"
                                                                    fill="#7B67FB"
                                                                />
                                                                <path
                                                                    d="M17.875 16C17.875 14.9687 17.0313 14.125 16 14.125C14.9687 14.125 14.125 14.9687 14.125 16C14.125 17.0312 14.9687 17.875 16 17.875C17.0312 17.875 17.875 17.0313 17.875 16Z"
                                                                    fill="#7B67FB"
                                                                />
                                                                <path
                                                                    d="M12.25 16C12.25 14.9687 11.4063 14.125 10.375 14.125C9.34375 14.125 8.5 14.9687 8.5 16C8.5 17.0312 9.34375 17.875 10.375 17.875C11.4062 17.875 12.25 17.0313 12.25 16Z"
                                                                    fill="#7B67FB"
                                                                />
                                                            </svg>
                                                        </button>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </button>
                                    );
                                })
                            ) : (
                                <div className="h-[54vh] grid items-center justify-center">
                                    <div className="-mt-16">
                                        {/* <IconEmpty /> */}
                                    </div>
                                </div>
                            )}
                        </Spin>
                    </div>
                </div>

                <ModalDelete
                    loading={loadingDelete}
                    open={openDelete}
                    title={title}
                    text={text}
                    handelOk={async () => {
                        // console.log('delete item')
                        setTimeout(async () => {
                            try {
                                setLoadingDelete(true);
                                const { data } = await serviceDelete(
                                    dataObject[privacyId]
                                );
                                if (data?.resultCode === 1) {
                                    setOpenDelete(false);
                                    setLoadingDelete(false);
                                    notify({
                                        title: t('Success'),
                                        description: t(
                                            'Successfully deleted data'
                                        ),
                                    });
                                    getPolicyList();
                                } else {
                                    setOpenDelete(false);
                                    setLoadingDelete(false);
                                    notify({
                                        type: 'error',
                                        title: t('Fail'),
                                        description: t('FailedDeleteData'),
                                        timeOut: 120000,
                                        closeable: true,
                                    });
                                }
                            } catch (err) {
                                setOpenDelete(false);
                                setLoadingDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('Fail'),
                                    description: t('FailedDeleteData'),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            }
                        });
                    }}
                    handelClose={() => {
                        setOpenDelete(false);
                        setLoading(false);
                    }}
                />
                <ModalConfirm
                    loading={loading}
                    open={confirmDelete}
                    title={confirmObject.title}
                    text={confirmObject.text}
                    confirmText={
                        lang === 'en' ? 'OK, I checked' : 'ฉันตรวจสอบแล้ว'
                    }
                    handelOk={() => {
                        setConfirmDelete(false);
                        setOpenDelete(true);
                    }}
                    handelClose={() => {
                        setConfirmDelete(false);
                        setLoading(false);
                    }}
                    icon={<IconWaring />}
                />
                <ModalRename
                    form={form}
                    loading={loading}
                    open={openRename}
                    handelOk={(value) => {
                        handelRename(value);
                        setOpenRename(false);
                    }}
                    handelClose={() => {
                        setOpenRename(false);
                        setLoading(false);
                    }}
                    placeholderNameTH={currentSelectName?.placeholderNameTH}
                    placeholderNameEN={currentSelectName?.placeholderNameEN}
                />
            </div>
            <DetailPrivacy
                currentSelectName={currentSelectName}
                templateBody={templateBody}
                data={currentSelectList}
                serviceHistory={serviceHistory}
                policyObject={{
                    privacyName,
                    privacyType,
                    privacyId,
                    privacyCompany,
                }}
                historyParamName={historyParamName}
                historyResultIdName={historyResultIdName}
                linkName={linkName}
                type={type}
                download={download}
            >
                {(previewLang) => children(previewLang)}
            </DetailPrivacy>
        </>
    );
};

ListPrivacy.propTypes = {
    data: PropTypes.array,
    pathEdit: PropTypes.string,
    stepEdit: PropTypes.string,
    setCurrentSelectList: PropTypes.func,
    currentSelectList: PropTypes.object,
    handelRename: PropTypes.func,
    currentSelectName: PropTypes.object,
    policyObject: PropTypes.object,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    form: PropTypes.object,
    getPolicyList: PropTypes.func,
    linkName: PropTypes.string,
    children: PropTypes.func,
    deleteObject: PropTypes.object,
    historyObject: PropTypes.object,
    confirmObject: PropTypes.object,
    templateBody: PropTypes.object,
    download: PropTypes.bool,
};

export default ListPrivacy;
